export default __webpack_public_path__ + "static/media/q18_04.47bf7dec.png";